"use strict";
exports.__esModule = true;
exports.SvgPaginationLastPage = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgPaginationLastPage = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 24 24", fill: "none" }, props),
    react_1["default"].createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.25 19c-.414 0-.75-.294-.75-.656V5.656c0-.362.336-.656.75-.656s.75.294.75.656v12.688c0 .362-.336.656-.75.656zM7.53 5.47a.75.75 0 00-1.06 1.06L11.94 12l-5.47 5.47a.75.75 0 101.06 1.06l6-6a.75.75 0 000-1.06l-6-6z", fill: "currentColor" }))); };
//# sourceMappingURL=PaginationLastPage.js.map